import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import feedviewsActions from '../../redux/feedviews/actions';
import './Feedviews.scss';

import FeedviewsList from '../../components/FeedviewsList';

function Feedviews({ feedviews, actions }) {
  useEffect(() => {
    actions.feedviewsRequest();
  }, [actions]);

  const onDelete = (feedviewId) => {
    actions.deleteFeedviewRequest(feedviewId);
  };

  return (
    <SidebarContainer title="Feedviews" openSubMenu="Inventory">
      <div className="feedviews-table">
        <FeedviewsList list={feedviews.feedviews} onDelete={onDelete} />
      </div>
    </SidebarContainer>
  );
}

Feedviews.propTypes = {
  feedviews: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ feedviews }) => ({ feedviews });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedviewsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Feedviews);
